import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

import '../../styles/edit-named-visitors.scss'

import {
    saveEditorAccessLevel,
    editEditors,
    fetchEditorAccessLevels,
    createEditors,
    refreshEditors,

    getNamedVisitors,
    resetVisitors,
    addNamedVisitors,
    editNamedVisitors,
    deleteNamedVisitors,
    turnOnEmails,
    getWishablePlays,
    getReservedPlays,
    reservePlays
} from "../../actions/common"
import {EditTitle} from "../utils/common";
import InnerHtml from '../utils/InnerHtmlWrapper'
import toast, { Toaster } from 'react-hot-toast';

import urlValidIcon from "../../assets/icons/url-valid.svg";


class EditNamedVisitors extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data: null,
            accessLevels: [],
            passInputVer: [],
            addVisitor: false,
            emailsAreOn: false,
            newVisitorId: "",
            newVisitorName: "",
            newVisitorEmail: "",
            newVisitorRetrievalCode: "",
            editVisitor: false,
            editVisitorId: "",
            editVisitorName: "",
            editVisitorEmail: "",
            editVisitorRetrievalCode: "",
            openVisitor: "",
            keywords: [],
            checkedKeywords: [],
            wishablePlays: [],
            reservedPlays: [],
            addPlayToVisitor: [],
            searchTerm: "",
        }
    }

    componentDidMount = prevProps => {
        const { data } = this.props
        const stateData = this.state.data
        
        if ((stateData === null) || (! _.isEqual(data, prevProps.data))) {
            this.setState({
                emailsAreOn: data.emailingEnabled,
                data: data.visitors.map(visitor => ({...visitor}))
            })
        }
    }

    componentDidUpdate = prevProps => {
        const { data } = this.props
        const stateData = this.state.data
        
        if ((stateData === null) || (! _.isEqual(data, prevProps.data))) {
            this.setState({
                emailsAreOn: data.emailingEnabled,
                data: data.visitors.map(visitor => ({...visitor}))
            })
        }
    }

    componentWillUnmount = () => {
        this.props.dispatch(resetVisitors())
    }

    refreshSelectChange = (editorId, level) => {
        const data = this.state.data.visitors.map(u => {
            if (editorId === u.editorId) {
                return { ...u, selectValue: level }
            } else {
                return u
            }
        })
        this.setState({ data: data })
    }

    saveAccessLevel = user => {
        const { dispatch } = this.props

        dispatch(saveEditorAccessLevel(user.editorId, user.selectValue, user.newPassword)).then(
            () => {
                dispatch(editEditors()).then(() => {
                    this.refreshSelectChange(user.editorId, "-")
                    window.location.href = window.location.href // quickfix. nem dispatch -> new order??? -> inputs stay in place
                })
            },
            () => {}
        )

    }

    accessLevelSelectOnChange = editorId => e => {
        this.refreshSelectChange(editorId, e.target.value)
    }

    infopultPassOnChange = editorId => e => {
        this.refreshInputChange(editorId, e.target.value)
    }
    
    refreshInputChange = (editorId, pass) => {
        const data = this.state.data.map(u => {
            if (editorId === u.editorId) {
                return { ...u, newPassword: pass }
            } else {
                return u
            }
        })
        this.setState({ data: data })
    }

    renderAccessLevelSelect = user => {
        const { accessLevels } = this.state
        
        return (
            <select disabled={! user.enabled} defaultValue={user.selectValue} onChange={this.accessLevelSelectOnChange(user.editorId)}>
                {accessLevels.map((o, idx) => (
                    <option key={idx} value={o}>{o}</option>
                ))}
            </select>
        )
    }
    
    onMailTurnOn = () => {
        if (window.confirm("Biztos vagy benne, hogy be akarod kapcsolni az email küldést?") == true) {
            this.props.dispatch(turnOnEmails()).then(() => {
                this.setState({ emailsAreOn: true })
                toast(
                    'Email küldés be lett kapcsolva', {
                        duration: 2000,
                        position: 'center-right',
                    }
                )
            }) 
        }
    }
    onaddVisitor = () => {
        this.props.dispatch(addNamedVisitors()).then(() => {
            this.setState({ reservedPlays: [], addPlayToVisitor: [] })
            this.setState({ addVisitor: false, newVisitorName: "", newVisitorEmail: ""},
            () => {
                this.props.dispatch(getNamedVisitors()).then((resp) => {
                    console.log({resp})
                    // this.setState({ data: resp.value.data.data.visitors })
                    this.setState({
                        data: resp.value.data.data.visitors.map(visitor => ({...visitor}))
                    })
                    this.setState({ addVisitor: true})
                })
            })
        })
    }
    onEdit = (user) => {
        console.log(user)
        this.setState({ editVisitor: false, editVisitorId: "", editVisitorName: "", editVisitorEmail: "", editVisitorRetrievalCode: "" },
        () => {
            this.setState({
                editVisitor: true,
                editVisitorId: user.visitorId,
                editVisitorName: user.name,
                editVisitorEmail: user.email,
                editVisitorRetrievalCode: user.retrievalCode
            })
            this.props.dispatch(getReservedPlays(user.visitorId)).then(
                (resp) => {
                    console.log({resp})
                    const plays = resp.value.data.data.seats
                    this.setState({ reservedPlays: plays, addPlayToVisitor: [] })
                }
            )
            this.props.dispatch(getWishablePlays()).then(
                (resp) => {
                    console.log({resp})
                    const plays = resp.value.data
                    this.setState({ wishablePlays: plays, addPlayToVisitor: [] })
                    const keywords = plays.reduce((acc, play) => {
                        if (play.keywords && play.keywords.length) {
                            return [...acc, ...play.keywords]
                        }
                        return acc
                    }, [])
                    this.setState({ keywords: _.uniq(keywords) })

                }
            )

                
        }
        );
    }

    createNewEditor = () => {
        const { newVisitorName, newVisitorEmail } = this.state
        if(newVisitorName === "") {
            toast(
                'A nevet és az email címet töltsd ki', {
                    duration: 2000,
                    position: 'center-right',
                }
            )
            return null
        }
        this.props.dispatch(addNamedVisitors(newVisitorName, newVisitorEmail)).then((response) => {
            this.setState({ openVisitor: response.value.data.href ? response.value.data.href.substring(18, (response.value.data.href.length - 5)) : "" })
            this.setState({ addVisitor: false, newVisitorName: "", newVisitorEmail: ""},
            () => {
                this.props.dispatch(getNamedVisitors()).then((resp) => {
                    this.setState({ data: resp.value.data.data.visitors })
                    if (this.state.openVisitor !== "") {
                        const usertoopen = resp.value.data.data.visitors.find(u => u.visitorId === this.state.openVisitor)
                        if (usertoopen) {
                            this.setState({
                                openVisitor: "",
                                editVisitor: true,
                                editVisitorId: usertoopen.visitorId,
                                editVisitorName: usertoopen.name,
                                editVisitorEmail: usertoopen.email,
                                editVisitorRetrievalCode: usertoopen.retrievalCode
                            })
                            this.props.dispatch(getWishablePlays()).then(
                                (resp) => {
                                    console.log({resp})
                                    const plays = resp.value.data
                                    this.setState({ wishablePlays: plays, addPlayToVisitor: [] })
                                    const keywords = plays.reduce((acc, play) => {
                                        if (play.keywords && play.keywords.length) {
                                            return [...acc, ...play.keywords]
                                        }
                                        return acc
                                    }, [])
                                    this.setState({ keywords: _.uniq(keywords) })

                                }
                            )
                        }
                    }
                })
            })
        })
    }

    renderInfopultPassInput = user => {
        return (
            <input
                type="text"
                placeholder={user.infopultAccess ? "új infopult jelszó" : ""}
                onChange={
                    this.infopultPassOnChange(user.editorId)
                }
            />
        )
    }

    renderNewEditor = () => {
        return (
            <div className={"user-row modalOver"} key={"c"}>
                <div className={"user-row-content"}>
                    <div className="namedvisitors icon remove" onClick={() => this.setState({ addVisitor: false })} />
                    <div className="title"><div>Új tiszteletjegyes</div></div>
                    <div>
                        <Toaster
                        toastOptions={{
                            className: '',
                            style: {
                                border: '1px solid #713200',
                                color: '#713200',
                                boxShadow: 'none',
                            },
                        }} />
                        <input
                        type="text"
                        placeholder="teljes név"
                        onChange={(e) => {
                            this.setState({ newVisitorName: e.target.value })
                        }}
                    />
                    </div>
                    <div>
                        <input
                            type="text"
                            placeholder="email"
                            onChange={(e) => {
                                this.setState({ newVisitorEmail: e.target.value })
                            }}
                        />
                    </div>
                    <div>
                        <button
                            onClick={() => this.createNewEditor()}
                            className={"button green"}
                        >Mentés</button> &nbsp; 
                        <button
                            onClick={() => this.setState({ addVisitor: false })}
                            className={"button red"}
                        >Mégse</button>
                    </div>
                </div>
            </div>
        )
    }


    renderUser = (user, index) => {

        const btnDisabled = (user.selectValue === user.accessLevel || ! user.enabled) && (user.newPassword == undefined )
        const btnClass = btnDisabled ? "disabled" : "green"
        const firstName = _.get(user, 'firstName', "")
        const lastName = _.get(user, 'lastName', "")
        const name = _.get(user, 'name', "")
        const email = _.get(user, 'email', "")
        const retrievalCode = _.get(user, 'retrievalCode', "")
        

        return [
            (
                <tr className={"user-row"} key={index}>
                    <td><div>név: {_.get(user, 'name', "")}</div></td>

                    <td><div>email: {email ? _.get(user, 'email', "") : <InnerHtml html={"&nbsp;"} />}</div></td>
                    <td><div>rendszám: <strong>{retrievalCode ? _.get(user, 'retrievalCode', "") : <InnerHtml html={"&nbsp;"} />}</strong></div></td>
                    <td>
                        <button
                            className={`button`}
                            onClick={() => this.onEdit(user)}
                        >Szerkesztés</button>
                    </td>
                </tr>
            ),
            (
                <tr className={"empty-row"} key={index + "a"}>
                    <td colSpan="4" />
                </tr>
            )
        ]
    }

    render = () => {

        const users = _.get(this.state, 'data', [])

        // if (users === null) return null

        return (
            <div className={`namedVisitorsDashboard edit edit-editors ${this.state.addVisitor ? "ztop" : ""} ${this.state.editVisitor ? "ztop" : ""}`}>
                <EditTitle>Tiszteletjegyesek</EditTitle>
                <br />
                <div className="firstBox">
                    {
                        this.state.emailsAreOn ?
                            <button className={"button grey"} disabled={true}>
                                <span>email küldés be van kapcsolva</span>
                            </button>
                            :
                            <button className={"button red"} onClick={() => {this.onMailTurnOn() }}>
                                <span>email küldés bekapcsolása</span>
                            </button>
                    }
                </div>
                <br />
                <table className={"user-list"}>
                    <tbody>
                        {typeof users !== "undefined" && users instanceof Array && users.length && users.map(this.renderUser)}
                        <tr className={"empty-row"} key={"b"}>
                            <td colSpan="4">
                                <div className={"icon add posToCenter"} onClick={this.onaddVisitor} />
                            </td>
                        </tr>
                    </tbody>
                </table>
                {this.state.addVisitor ? this.renderNewEditor() : null}
                {this.state.editVisitor ? (
                    <div className={"user-row modalOver"}>
                        <div className={"user-row-content"}>
                        <div className="namedvisitors icon remove" onClick={() => this.setState({ editVisitor: false, editVisitorId: "", editVisitorName: "", editVisitorEmail: "", editVisitorRetrievalCode: "" })} />
                            <div className="title"><div>Tiszteletjegyes szerkesztése</div></div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="teljes név"
                                    value={this.state.editVisitorName}
                                    onChange={(e) => {
                                        this.setState({ editVisitorName: e.target.value })
                                    }}
                                />
                            </div>
                            <div>
                                <input
                                    type="text"
                                    placeholder="email"
                                    value={this.state.editVisitorEmail}
                                    onChange={(e) => {
                                        this.setState({ editVisitorEmail: e.target.value })
                                    }}
                                />
                            </div>
                            <div>
                                <span className="label">Rendszám:</span>
                                <span className="value"> <strong>{this.state.editVisitorRetrievalCode}</strong></span>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        this.props.dispatch(editNamedVisitors(
                                            this.state.editVisitorId,
                                            this.state.editVisitorName,
                                            this.state.editVisitorEmail
                                        )).then(() => {
                                            // this.setState({ editVisitor: false, editVisitorId: "", editVisitorName: "", editVisitorEmail: "" },
                                            // () => {
                                                this.props.dispatch(getNamedVisitors()).then((resp) => {
                                                    this.setState({ data: resp.value.data.data.visitors })
                                                })
                                            // })
                                        })
                                    }}
                                    className={"button green"}
                                >Mentés</button> &nbsp; 
                                <button
                                    onClick={() => {
                                        this.setState({ editVisitor: false, editVisitorId: "", editVisitorName: "", editVisitorEmail: "", editVisitorRetrievalCode: "" })
                                    }}
                                    className={"button red"}
                                >Mégse</button>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        if (window.confirm("Biztos vagy benne, hogy törölni akarod ezt a felhasználót?") == true) {
                                            this.props.dispatch(deleteNamedVisitors(this.state.editVisitorId)).then(() => {
                                                 this.setState({ editVisitor: false, editVisitorId: "", editVisitorName: "", editVisitorEmail: "", editVisitorRetrievalCode: "" })
                                                this.props.dispatch(getNamedVisitors()).then((resp) => {
                                                    this.setState({ data: resp.value.data.data.visitors })
                                                })
                                            })
                                        }
                                    }}
                                    className={"button red"}
                                >Törlés</button>
                            </div>
                            <div>
                                { 
                                    // getReservedPlays
                                    /*
                                    this.state.reservedPlays.length ? (
                                        <div className="reserved-plays">
                                            <strong>Foglalások:</strong><br></br>
                                            <table className="reserved-plays-table">
                                                <tbody>
                                                    <tr>
                                                        <th>Előadás</th>
                                                        <th>Időpont</th>
                                                        <th>Helyszín</th>
                                                        <th>Foglalás</th>
                                                        <th>&nbsp;</th>
                                                    </tr>
                                                    {this.state.reservedPlays.map((play, idx) => (
                                                        <tr key={idx}>
                                                            <td>{play.title}</td>
                                                            <td>{play.start}</td>
                                                            <td>{play.location}</td>
                                                            <td>{play.wonSeats} db</td>
                                                            <td>
                                                                <button
                                                                    className={"button red"}
                                                                    onClick={() => {
                                                                        this.props.dispatch(reservePlays(
                                                                            this.state.editVisitorId,
                                                                            play.playId,
                                                                            0
                                                                        )).then((resp) => {
                                                                            this.props.dispatch(getWishablePlays()).then(
                                                                                (resp) => {
                                                                                    console.log({resp})
                                                                                    const plays = resp.value.data
                                                                                    this.setState({ wishablePlays: plays, addPlayToVisitor: [] })
                                                                                }
                                                                            )
                                                                        })




                                                                        this.props.dispatch(reservePlays(
                                                                            this.state.editVisitorId,
                                                                            play.playId,
                                                                            0 // remove reservation
                                                                        )).then((resp) => {
                                                                            this.props.dispatch(getReservedPlays(this.state.editVisitorId)).then(
                                                                                (resp) => {
                                                                                    console.log({resp})
                                                                                    const plays = resp.value.data
                                                                                    this.setState({ reservedPlays: plays, addPlayToVisitor: [] })
                                                                                }
                                                                            )
                                                                        })
                                                                    }}
                                                                >Törlés</button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null
                                    */
                                   // get the plays that have playId that are in the reservedPlays array
                                    this.state.reservedPlays.length ? (
                                        <div className="reserved-plays">
                                            <strong>Foglalások:</strong><br></br>
                                            <table className="reserved-plays-table">
                                                <tbody>
                                                    <tr>
                                                        <th>Előadás</th>
                                                        <th>Időpont</th>
                                                        <th>Helyszín</th>
                                                        <th>applikációból</th>
                                                        <th>Tiszteletjegyek</th>
                                                        <th>Infopultból</th>
                                                        <th>Tiszteletjegy</th>
                                                    </tr>
                                                    {
                                                        this.state.wishablePlays.map((play, idx) => (
                                                            // if play.playId is in the reservedPlays array, then render the row
                                                            this.state.reservedPlays.find(rp => rp.playId === play.playId) ? (
                                                                <>
                                                                <tr key={idx}>
                                                                    <td>{play.title}</td>
                                                                    <td>{play.start}</td>
                                                                    <td>{play.location}</td>
                                                                    <td>{play.appSeats}</td>
                                                                    <td>{play.complimentaryWonSeats}</td>
                                                                    <td>{play.inPersonSeats}</td>
                                                                    <td>
                                                                        <input
                                                                            type="number"
                                                                            min="0"
                                                                            placeholder="tiszteletjegyek száma"
                                                                            value={this.state.reservedPlays.filter(rp => rp.playId === play.playId)[0].wonSeats}
                                                                            onChange={(e) => {
                                                                                const reservedPlays = this.state.reservedPlays.map(p => {
                                                                                    if (p.playId === play.playId) {
                                                                                        return { ...p, wonSeats: e.target.value }
                                                                                    }
                                                                                    return p
                                                                                })
                                                                                this.setState({ reservedPlays })
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr key={idx + "a"}>
                                                                    <td colSpan="6">
                                                                        {
                                                                            /*
                                                                            play.keywords && play.keywords.length ? (
                                                                                <div className="keywords">
                                                                                    <strong>Kulcsszavak:</strong> {play.keywords.join(", ")}
                                                                                </div>
                                                                            ) : null
                                                                            */
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <button
                                                                            className={"button green"}
                                                                            onClick={() => {
                                                                                this.props.dispatch(reservePlays(
                                                                                    this.state.editVisitorId,
                                                                                    this.state.wishablePlays.filter(p => p.playId === play.playId)[0].playId,
                                                                                    this.state.reservedPlays.filter(rp => rp.playId === play.playId)[0].wonSeats
                                                                                )).then((resp) => {
                                                                                    this.props.dispatch(getWishablePlays()).then(
                                                                                        (resp) => {
                                                                                            console.log({resp})
                                                                                            const plays = resp.value.data
                                                                                            this.setState({ wishablePlays: plays, addPlayToVisitor: [] })
                                                                                        }
                                                                                    )
                                                                            
                                                                                    this.props.dispatch(getReservedPlays(this.state.editVisitorId)).then(
                                                                                        (resp) => {
                                                                                            console.log({resp})
                                                                                            const plays = resp.value.data.data.seats
                                                                                            this.setState({ reservedPlays: plays, addPlayToVisitor: [] })
                                                                                        }
                                                                                    )
                                                                                })
                                                                            }}
                                                                        >Mentés</button> { } 
                                                                        <button
                                                                            className={"button red"}
                                                                            onClick={() => {
                                                                                this.props.dispatch(reservePlays(
                                                                                    this.state.editVisitorId,
                                                                                    play.playId,
                                                                                    0
                                                                                )).then((resp) => {
                                                                                    this.props.dispatch(getWishablePlays()).then(
                                                                                        (resp) => {
                                                                                            console.log({resp})
                                                                                            const plays = resp.value.data
                                                                                            this.setState({ wishablePlays: plays, addPlayToVisitor: [] })
                                                                                        }
                                                                                    )
                                                                                })
                                                                                this.props.dispatch(reservePlays(
                                                                                    this.state.editVisitorId,
                                                                                    play.playId,
                                                                                    0 // remove reservation
                                                                                )).then((resp) => {
                                                                                    this.props.dispatch(getReservedPlays(this.state.editVisitorId)).then(
                                                                                        (resp) => {
                                                                                            console.log({resp})
                                                                                            const plays = resp.value.data.data.seats
                                                                                            this.setState({ reservedPlays: plays, addPlayToVisitor: [] })
                                                                                        }
                                                                                    )
                                                                                })
                                                                            }}
                                                                        >Törlés</button>
                                                                    </td>
                                                                </tr>
                                                                </>
                                                            ) : null
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    ) : null

                                }
                                <div className="wishable-plays">
                                    <div><strong>Sorszámos előadások:</strong></div>
                                    <div className="filter-by-keywords">
                                        <strong>szűrés:</strong>
                                        <input
                                            type="text"
                                            placeholder="kulcsszó keresés"
                                            value={this.state.searchTerm}
                                            onChange={(e) => {
                                                this.setState({ searchTerm: e.target.value })
                                                console.log("searchTerm", e.target.value)
                                            }}
                                        />
                                    </div>
                                    <div className="plays">
                                        <table className="plays-table">
                                            <tbody>
                                                <tr>
                                                    <th>Előadás</th>
                                                    <th>Időpont</th>
                                                    <th>Helyszín</th>
                                                    <th>applikációból</th>
                                                    <th>Tiszteletjegyek</th>
                                                    <th>Infopultból</th>
                                                    <th>Tiszteletjegy</th>
                                                </tr>
                                                {
                                                this.state.wishablePlays.length &&
                                                this.state.wishablePlays.filter(play => {
                                                    console.log(this.state.reservedPlays)
                                                    return play.keywords && play.keywords.some(k => k.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").indexOf(this.state.searchTerm.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")) == 0 ) && play.playId !== this.state.reservedPlays.find(rp => rp.playId === play.playId)?.playId
                                                    // return only items that playId is not in the reservedPlays item with the same playId
                                                    // return play.playId && play.playId !== this.state.reservedPlays.find(rp => rp.playId === play.playId)?.playId &&
                                                }).map((play, idx) => (
                                                    <>
                                                    <tr key={idx}>
                                                        <td>{play.title}</td>
                                                        <td>{play.start}</td>
                                                        <td>{play.location}</td>
                                                        <td>{play.appSeats}</td>
                                                        <td>{play.complimentaryWonSeats}</td>
                                                        <td>{play.inPersonSeats}</td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                min="0"
                                                                placeholder="tiszteletjegyek száma"
                                                                value={play.reserveSeats || ""}
                                                                onChange={(e) => {
                                                                    const wishablePlays = this.state.wishablePlays.map(p => {
                                                                        if (p.playId === play.playId) {
                                                                            return { ...p, reserveSeats: e.target.value }
                                                                        }
                                                                        return p
                                                                    })
                                                                    this.setState({ wishablePlays })
                                                                }}
                                                            />
                                                        </td>
                                                    </tr>
                                                    <tr key={idx + "a"}>
                                                        <td colSpan="6">
                                                            {
                                                                /*
                                                                play.keywords && play.keywords.length ? (
                                                                    <div className="keywords">
                                                                        <strong>Kulcsszavak:</strong> {play.keywords.join(", ")}
                                                                    </div>
                                                                ) : null
                                                                */
                                                            }
                                                        </td>
                                                        <td>
                                                            <button
                                                                className={"button green"}
                                                                onClick={() => {
                                                                    this.props.dispatch(reservePlays(
                                                                        this.state.editVisitorId,
                                                                        this.state.wishablePlays.filter(p => p.playId === play.playId)[0].playId,
                                                                        this.state.wishablePlays.filter(p => p.playId === play.playId)[0].reserveSeats
                                                                    )).then((resp) => {
                                                                        this.props.dispatch(getWishablePlays()).then(
                                                                            (resp) => {
                                                                                console.log({resp})
                                                                                const plays = resp.value.data
                                                                                this.setState({ wishablePlays: plays, addPlayToVisitor: [] })
                                                                            }
                                                                        )
                                                                
                                                                        this.props.dispatch(getReservedPlays(this.state.editVisitorId)).then(
                                                                            (resp) => {
                                                                                console.log({resp})
                                                                                const plays = resp.value.data.data.seats
                                                                                this.setState({ reservedPlays: plays, addPlayToVisitor: [] })
                                                                            }
                                                                        )
                                                                    })
                                                                }}
                                                            >Mentés</button>
                                                        </td>
                                                    </tr>
                                                    </>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null
                }   
            </div>

        )
    }
}



export default connect(store => {
    return {
        data: store.base.data || [],
        accessLevels: store.editors.accessLevels
    }
})(EditNamedVisitors)
